module.exports = __webpack_public_path__ + "images/referenzen/produktfilm/graeff_produktfilm.jpg";